module.exports = __webpack_public_path__ + "img/rocketship-2.f0727b1f.jpg";